module.exports = __webpack_public_path__ + "static/media/match.2a57bfe6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/match.svg
// module id = 617
// module chunks = 0